



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CheckSheetGroup from '@/components/CheckSheetGroup.vue';
import CheckSheetGroupRow from '@/components/CheckSheetGroupRow.vue';
import CheckSheetItem from '@/components/CheckSheetItem.vue';
import CheckSheetDropdown from '@/components/CheckSheetDropdown.vue';
import TypeaheadSearch from '@/components/TypeaheadSearch.vue';
import CheckSheetTypeDropdown from '@/components/CheckSheetTypeDropdown.vue';
import ReportPhotos from '@/components/ReportPhotos.vue';
import LovSelect from '@/components/LovSelect.vue';

import Route from 'vue-router'
import * as moment from 'moment'

// Models
import { Report, ReportPhoto } from '../models/report';
import { Lov } from '../models/lov';
import { Machine } from '../models/machine';

// Service
import { Datasource } from '../services/datasource'
import Machines from '../views/Machines.vue';

@Component({
  components: {
    CheckSheetItem,
    CheckSheetGroup,
    CheckSheetGroupRow,
    CheckSheetDropdown,
    TypeaheadSearch,
    LovSelect,
    CheckSheetTypeDropdown,
    ReportPhotos
  },
})
export default class EditReport extends Vue {

  @Prop()
  reportId:string;

  source:Datasource

  // Data Placeholder
  greases: Lov[] = []
  workDetails: Lov[] = []
  lubricant: Lov[] = []
  photoCaptions: Lov[] = []
  report:Report = new Report();

  /* ======= KEY PAIRS (for CheckSheetGroupRow) ======== */

  /**
   * FIXME: Move this to CheckSheetGroupRow
   * 
   * Convert formatted key
   * 
   * Each key has following format: 
   * 
   *  [col=0]#[type=bool]![key=label.replace(/ /g, '_').toLowerCase()];Label
   * 
   */
  private keyPairs(...labels: string[]): {valueKey: string, label: string, type: string, col: number}[] {
    return labels.map((raw) => {
      const m = raw.match(/((\d+)\#)?((.*)\!)?((.*)\;)?(.*)/)
      const label = m![7]
      const col = +m![2] || 0
      const type = m![4] || 'bool'                                      // extract type - default to 'bool'
      const valueKey = m![6] || label.replace(/ /g, '_').toLowerCase()  // create slug
      return {
        label,
        valueKey,
        type,
        col
      }
    })
  }

  constructor() {
    super()
    this.source = Datasource.shared
  }

  /**
   * Perpare the sources
   */
  mounted() {
    this.source.lov()
      .then((lov:Lov[]) => {
        this.greases = lov.filter((o: Lov) => o.type == 'grease')
        this.workDetails = lov.filter((o: Lov) => o.type == 'work_detail')
        this.lubricant = lov.filter((o: Lov) => o.type == 'lubricant')
        this.photoCaptions = lov.filter((o: Lov) => o.type == 'report_photo_caption')
      })
      .catch(console.error)
    
    var $ = (window as any).jQuery || {};
    var vm = this

    $('#date-of-service, #report-date').datepicker({autoclose: true})
    $('#date-of-service').datepicker().on('changeDate', function(e:any) {
      vm.report.date_of_service = moment(e.date).toDate()
    });
    $('#report-date').datepicker().on('changeDate', function(e:any) {
      vm.report.report_date = moment(e.date).toDate()
    });

  }

  load(id: string) {
    console.log('Perform loading on report', id)
    if (id === 'new') {
      this.report = new Report()
    }
    else {
      this.source.report(id)
        .then((report) => {
          this.report = report
        })
        .catch(console.error)
    }
  }

  @Watch('reportId')
  pageIdChanged(newVal: string, oldVal: string) {
    console.log(oldVal, '=>', newVal)
    this.load(newVal)
  }

  // @Watch('report.serial_number')
  // serialNumberChanged(newVal:string, oldVal:string) {
  //   console.log(oldVal, '=>', newVal)
  //   this.source.searchMachines(newVal)
  //       .then(([machines, total]) => {
  //           console.log(machines)
  //           if(machines.length == 1){
  //             this.report.model = machines[0].model
  //             this.report.machine_number = machines[0].machine_number
  //             this.report.client_name = machines[0].client_name
  //           }
  //       })
  //       .catch(console.error)
  // }

  serialNumberSelected(machine:Machine){
    console.log(machine)
    this.report.serial_number = machine.serial_number
    this.report.model = machine.model
    this.report.machine_number = machine.machine_number
    this.report.client_name = machine.client_name
  }

  dateFormatChange(date:Date){
    return moment(date).format('DD-MMM-YYYY')
  }
  
  /**
   * Perform Save
   */
  async save(suffix:string = ''): Promise<string> {
    // Perform Save
    let reportId:number = -1
    if (this.reportId == "new") {
      reportId = await this.source.createReport(this.report)
    }
    else {
      // Perform upload if required.
      await (this.$refs.photos as ReportPhotos).uploadIfNeeded()
      // At this point ALL Urls are now real URL not Data URL.
      reportId = await this.source.updateReport(this.report)
    }

    this.$router.push({
      path: '/report/' + reportId + '/'+ suffix
    })

    var $ = (window as any).jQuery || {};
    $('.page-content-wrapper').pgNotification({
        style: 'flip',
        message: 'Report saved.',
        timeout: 0,
        type: 'success'
    }).show();

    return 'done'
  }
}

